import { Button, Icon, Modal, Typography } from "@/components/atoms";

interface UpgradedPlanWelcomeModalProps {
  open: boolean;
  onClose: () => void;
  planName?: string;
  trialDaysLeft?: number;
  trialStartDate?: string | null;
  trialEndDate?: string | null;
}

export const UpgradedPlanWelcomeModal = ({
  open,
  onClose,
  planName = "Enterprise",
  trialDaysLeft = 30,
  trialStartDate,
  trialEndDate,
}: UpgradedPlanWelcomeModalProps) => {
  // Format date for display (e.g., "6 Feb")
  const formatDate = (dateString: string | null | undefined) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleDateString("en-AU", { day: "numeric", month: "short" });
  };

  const formattedStartDate = formatDate(trialStartDate);
  const formattedEndDate = formatDate(trialEndDate);

  const renderFeaturedIcon = () => (
    <div className="flex justify-center">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#E9E5F4]">
        <Icon name="rm-logo-emblem" size="xl" className="text-[#5B3A99]" isCustom />
      </div>
    </div>
  );

  const renderButtons = () => (
    <Button variant="primary" size="lg" onClick={onClose} className="w-full">
      Continue to Dashboard
    </Button>
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      variant="web-small"
      featuredIcon={renderFeaturedIcon()}
      renderButtons={renderButtons}
      headerClassName="items-center text-center"
      className="max-w-[400px]"
    >
      <div className="flex flex-col gap-4 text-center">
        <Typography variant="h2">Welcome to your new {planName} plan</Typography>
        <Typography variant="paragraph" className="text-neutral-dark-gray">
          Your account has been upgraded to the {planName} plan at no extra cost during your transition period.
        </Typography>
        <Typography variant="paragraph" className="text-neutral-dark-gray">
          Your <span className="font-semibold">{trialDaysLeft}-day trial</span> runs from{" "}
          <span className="font-semibold">{formattedStartDate ?? "today"}</span> to{" "}
          <span className="font-semibold">{formattedEndDate ?? "end of trial"}</span>.
        </Typography>
        <Typography variant="paragraph" className="text-neutral-dark-gray">
          To continue using RideMinder without interruption after the trial ends, please select a subscription plan before{" "}
          <span className="font-semibold">{formattedEndDate ?? "end of trial"}</span>.
        </Typography>
      </div>
    </Modal>
  );
};
